const relativeFormatter = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });

const sameYearFormatter = new Intl.DateTimeFormat('en', {
  month: 'short',
  day: 'numeric',
});

const fullDateFormatter = new Intl.DateTimeFormat('en', {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
});

/**
 * Standard human-readable date: "30 minutes ago", "yesterday", "Jul 10", "Jun 1, 2023".
 */
export function formatRelativeDate(dateInput, now = new Date()) {
  const date = new Date(dateInput);
  if (Number.isNaN(date.getTime())) return '';

  const diffMs = now.getTime() - date.getTime();
  const absMs = Math.abs(diffMs);
  const sign = diffMs >= 0 ? -1 : 1; // RelativeTimeFormat: negative = past

  if (absMs < 60_000) {
    return diffMs >= 0 ? 'just now' : 'in a moment';
  }

  if (absMs < 3_600_000) {
    const minutes = Math.round(absMs / 60_000);
    return relativeFormatter.format(sign * minutes, 'minute');
  }

  if (absMs < 86_400_000) {
    const hours = Math.round(absMs / 3_600_000);
    return relativeFormatter.format(sign * hours, 'hour');
  }

  if (absMs < 7 * 86_400_000) {
    const days = Math.round(absMs / 86_400_000);
    return relativeFormatter.format(sign * days, 'day');
  }

  if (date.getFullYear() === now.getFullYear()) {
    return sameYearFormatter.format(date);
  }
  return fullDateFormatter.format(date);
}

export function formatAbsoluteDate(dateInput) {
  const date = new Date(dateInput);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString();
}
